// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3rXlb","footer_inner_flex":"Footer_footer_inner_flex__Nnpcb","footer_inner":"Footer_footer_inner__VuBX4"};